
(function () {
  const grid = document.getElementById('homeWorkGrid');
  if (!grid) return;

  const isEs = location.pathname.startsWith('/es/') || location.pathname === '/es';
  const projectHref = (slug) => (isEs ? `/es/proyecto/${slug}/` : `/work/${slug}/`);

  function cardHTML(p) {
    const tags = p.tags.map(t => `<span>${t}</span>`).join('');
    const variantClass = p.variant ? ` work-card--${p.variant}` : '';
    return `
      <a class="work-card${variantClass}" href="${projectHref(p.slug)}" data-slug="${p.slug}">
        <div class="work-card__img-wrap">
          <img src="${p.cover_image}" alt="${p.name}" class="work-card__img" loading="lazy" />
        </div>
        <div class="work-card__meta">
          <p class="work-card__name">${p.name}</p>
          <p class="work-card__subtitle">${p.subtitle}</p>
          <div class="work-card__tags">${tags}</div>
        </div>
      </a>`;
  }

  function renderGrid(projects) {
    grid.innerHTML = '';
    grid.removeAttribute('aria-busy');

    if (!projects.length) return;

    let i = 0;
    while (i < projects.length) {
      const full = document.createElement('div');
      full.className = 'work-row work-row--full';
      full.innerHTML = cardHTML(projects[i]);
      grid.appendChild(full);
      i += 1;

      if (i < projects.length) {
        const a = projects[i];
        const b = projects[i + 1];
        const row = document.createElement('div');
        row.className = 'work-row work-row--half' + (b ? '' : ' work-row--orphan');
        row.innerHTML = cardHTML(a) + (b ? cardHTML(b) : '');
        grid.appendChild(row);
        i += b ? 2 : 1;
      }
    }
  }

  fetch(`/api/projects?lang=${isEs ? 'es' : 'en'}`)
    .then(r => r.json())
    .then(renderGrid)
    .catch(err => {
      console.error('No se pudieron cargar los proyectos del bloque Work de la home:', err);
      grid.removeAttribute('aria-busy');
    });
})();
